export function validateRouteFormat(route: string): string | null {
  if (!route) return "Route must not be empty";
  if (route.startsWith("/") || route.endsWith("/"))
    return "Route must not start or end with '/'";
  if (route.includes("//")) return "Route must not contain '//'";
  if (!/^[a-zA-Z0-9\-_/]+$/.test(route))
    return "Only alphanumeric characters, hyphens, underscores, and slashes are allowed";
  return null;
}
